const SectionHeader = {
    baseStyle: {
        h: '40px',
        w: '100%',
    },
    variants: {
        standard: {
            bg: 'gray.600',
            color: 'white',
        },
        subsection: {
            bg: 'gray.100',
            color: 'black',
        },
        gray: {
            bg: 'gray.100',
            color: 'black',
        },
    },
    defaultProps: {
        variants: 'standard',
    },
};
export default SectionHeader;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VjdGlvbkhlYWRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uLy4uL2FwZXgtb25saW5lL2NvbXBvbmVudC1saWJyYXJ5L3RoZW1lL2NvbXBvbmVudHMvU2VjdGlvbkhlYWRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxNQUFNLGFBQWEsR0FBeUI7SUFDMUMsU0FBUyxFQUFFO1FBQ1QsQ0FBQyxFQUFFLE1BQU07UUFDVCxDQUFDLEVBQUUsTUFBTTtLQUNWO0lBQ0QsUUFBUSxFQUFFO1FBQ1IsUUFBUSxFQUFFO1lBQ1IsRUFBRSxFQUFFLFVBQVU7WUFDZCxLQUFLLEVBQUUsT0FBTztTQUNmO1FBQ0QsVUFBVSxFQUFFO1lBQ1YsRUFBRSxFQUFFLFVBQVU7WUFDZCxLQUFLLEVBQUUsT0FBTztTQUNmO1FBQ0QsSUFBSSxFQUFFO1lBQ0osRUFBRSxFQUFFLFVBQVU7WUFDZCxLQUFLLEVBQUUsT0FBTztTQUNmO0tBQ0Y7SUFDRCxZQUFZLEVBQUU7UUFDWixRQUFRLEVBQUUsVUFBVTtLQUNyQjtDQUNGLENBQUE7QUFFRCxlQUFlLGFBQWEsQ0FBQSIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IENvbXBvbmVudFN0eWxlQ29uZmlnIH0gZnJvbSAnQGNoYWtyYS11aS9yZWFjdCdcblxuY29uc3QgU2VjdGlvbkhlYWRlcjogQ29tcG9uZW50U3R5bGVDb25maWcgPSB7XG4gIGJhc2VTdHlsZToge1xuICAgIGg6ICc0MHB4JyxcbiAgICB3OiAnMTAwJScsXG4gIH0sXG4gIHZhcmlhbnRzOiB7XG4gICAgc3RhbmRhcmQ6IHtcbiAgICAgIGJnOiAnZ3JheS42MDAnLFxuICAgICAgY29sb3I6ICd3aGl0ZScsXG4gICAgfSxcbiAgICBzdWJzZWN0aW9uOiB7XG4gICAgICBiZzogJ2dyYXkuMTAwJyxcbiAgICAgIGNvbG9yOiAnYmxhY2snLFxuICAgIH0sXG4gICAgZ3JheToge1xuICAgICAgYmc6ICdncmF5LjEwMCcsXG4gICAgICBjb2xvcjogJ2JsYWNrJyxcbiAgICB9LFxuICB9LFxuICBkZWZhdWx0UHJvcHM6IHtcbiAgICB2YXJpYW50czogJ3N0YW5kYXJkJyxcbiAgfSxcbn1cblxuZXhwb3J0IGRlZmF1bHQgU2VjdGlvbkhlYWRlclxuIl19